import * as validationConfigurations from "./sheet-validation-config";
import isEmpty from "lodash/isEmpty";

const _getSheetValidation = sheetName => {
  return validationConfigurations[
    `${sheetName.toUpperCase()}_SHEET_VALIDATION`
  ];
};

const _getColIdx = col => +col || col.charCodeAt() - 65;

const _getColName = (validationCfg, columns) => {
  if (validationCfg.col) {
    return columns[_getColIdx(validationCfg.col)];
  }
  return validationCfg.colName;
};

const generateColumnValidations = (sheetName, sheetData) => {
  const configuredValidation = _getSheetValidation(sheetName);

  if (!configuredValidation) return null;

  if (!sheetData || sheetData.length < 1) return null;

  const columns = Object.keys(sheetData[0]);

  // apply with configured columns;
  if (configuredValidation instanceof Array) {
    return configuredValidation.reduce((validationObj, validationCfg) => {
      //? configured col can be word or digit (A, B, C...or..0,1,2);
      if (isEmpty(validationCfg)) return validationObj;

      const colName = _getColName(validationCfg, columns);

      validationObj[colName] = { ...validationCfg };

      return validationObj;
    }, {});
  }

  if (isEmpty(configuredValidation)) return {};

  const startCol = _getColIdx(configuredValidation.col);
  // apply for all column from startCol;
  return columns.slice(startCol).reduce((validationObj, colName) => {
    validationObj[colName] = { ...configuredValidation };

    return validationObj;
  }, {});
};

export { generateColumnValidations };
